/*
 * Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import { Directive, Input } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator, ValidatorFn } from '@angular/forms';
import { SegmentReport } from '../../../../models/reports/segment-report.model';

/**
 * This is a directive that is applied to an html input element
 * Makes sure the Global segment of this element is a substring of its input Ev/Ice segment
 */
@Directive({
    selector: '[appGlobalSegment]',
    providers: [{ provide: NG_VALIDATORS, useExisting: GlobalSegmentValidatorDirective, multi: true }],
    standalone: false
})

export class GlobalSegmentValidatorDirective implements Validator {
  @Input('appGlobalSegment') globalSegment = new SegmentReport();

  validate(control: AbstractControl): ValidationErrors | null {
    return this.globalSegment ? globalSegmentValidator(this.globalSegment)(control) : null;
  }
}

/**
 * Makes sure global segment of the element is a substring of the input
 * Converts all strings to lowercase, ignores case
 * @param element the element that we compare the EvIceSegment to the GlobalSegment
 * @return either the validation error or null
 */
export function globalSegmentValidator(element: SegmentReport): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let invalid: boolean;
    if (control.value !== null && control.value !== undefined) {
      invalid = !element.propSegment.toLowerCase().includes(element.globalSegment.toLowerCase());
    }
    return invalid ? {invalidGlobalSegment: {value: control.value}} : null;
  };
}
